import * as React from "react"
import Particles from "react-tsparticles"
import { loadFull } from "tsparticles"
import cs from "classnames"
import styles from "./Forms.module.scss"

interface Props extends React.PropsWithChildren {
  id: string
  classes?: {
    root?: string
    childrenWrapper?: string
    particlesClassName?: string
  }
  loading?: boolean
}

export const WithParticleOverlay = ({ id, classes, children, loading }: Props) => {
  return (
    <div className={cs(styles.relativeFieldWrapper, classes?.root)}>
      <div className={cs(classes?.childrenWrapper, { [styles.loading]: loading })}>{children}</div>

      {loading && (
        <div className={cs(styles.particlesWrapper, classes?.particlesClassName)}>
          <Particles
            id={id}
            init={loadFull}
            options={{
              fullScreen: { enable: false, zIndex: 0 },
              pauseOnOutsideViewport: true,
              background: { color: { value: "transparent" } },
              fpsLimit: 120,
              particles: {
                color: { value: "#ffffff" },
                links: { color: "#ffffff", distance: 60, enable: true, opacity: 1, width: 1 },
                collisions: { enable: false },
                move: {
                  direction: "none",
                  enable: true,
                  outModes: { default: "bounce" },
                  random: false,
                  speed: 1,
                  straight: false,
                },
                number: { density: { enable: true, area: 10 }, value: 10 },
                opacity: { value: 0.5 },
                shape: { type: "circle" },
                size: { value: { min: 1, max: 5 } },
              },
              detectRetina: true,
            }}
          />
        </div>
      )}
    </div>
  )
}
